<script>
  import Upload from "../components/recettes/RecettesLoadImage.svelte";
  import ListeImage from "../components/recettes/RecettesImageListe.svelte";
  //import Test from "../components/MailSend.svelte";
  //import * as recettes from "../store/Mails.json"; // => lecture fichier json local ({JSON.stringify(recettes)})

  import * as data from "../store/Recettes.json";
  import { readable } from "svelte/store";

  export const recettes = readable(null, function start(set) {
    set(data);

    return function stop() {
      console.log("RecettesStore Stopped");
    };
  });
</script>

<div class="container">
  <Upload />
  <ListeImage />
</div>
